import React from 'react';
import { ColumnH1 } from 'lib/components/Typography';
import { Tooltip } from 'lib/components/Tooltip';

type TabHeaderProps = {
  title: string;
  subheading?: string;
  subheadingToolTip?: string;
  children?: React.ReactNode;
};

export function TabHeader({
  title,
  subheading,
  subheadingToolTip,
  children
}: TabHeaderProps) {
  return (
    <div className="flex justify-between items-center p-6 border-b border-column-gray-100">
      <div>
        <ColumnH1>{title}</ColumnH1>
        {subheading && (
          <Tooltip helpText={subheadingToolTip ?? ''} position="bottom">
            <div className="mt-3 text-m leading-6 text-column-gray-400 max-w-xl break-words">
              {subheading}
            </div>
          </Tooltip>
        )}
      </div>
      <div className="flex items-center gap-4">{children}</div>
    </div>
  );
}
